<template>
  <v-container fluid>
    <mp-external-form  ref="externalForm" target="_self" />
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1>{{$t("message.changePassword.title")}}</h1>
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12" md="8">
        <mp-error :errors="view.errors" message-key="message.changePassword.error." />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <div>{{$t("message.changePassword.desc.text1")}}<br>{{$t("message.changePassword.desc.text2")}}<br>{{$t("message.changePassword.desc.text3")}}</div>
      </v-col>
    </v-row>

    <!-- パスワード -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label no-color>{{$t("message.changePassword.label.password")}}</mp-label>
        <!-- <v-subheader>{{$t("message.changePassword.label.password")}}</v-subheader> -->
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          :append-icon="view.show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="view.show ? 'text' : 'password'"
          @click:append="view.show = !view.show"
          autocomplete="off"
          hide-details
          v-model="form.password"
          v-bind:placeholder="$t('message.changePassword.ph.password')"
          id="password"
          solo
          maxlength="100"
        ></v-text-field>
        <v-text-field
          :append-icon="view.showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
          :type="view.showConfirm ? 'text' : 'password'"
          class="mt-4"
          @click:append="view.showConfirm = !view.showConfirm"
          autocomplete="off"
          hide-details
          v-model="form.passwordConfirm"
          v-bind:placeholder="$t('message.changePassword.ph.passwordConfirm')"
          id="passwordConfirm"
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 変更ボタン -->
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="12"
        md="8"
      >
        <div>
          <mp-button @click="clickEntry">{{$t("message.changePassword.button.change")}}</mp-button>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpError from '@/components/item/MpError.vue'
import MpExternalForm from '@/components/item/MpExternalForm.vue'
import Cookies from 'js-cookie'
import constantValue from '@/constantValue'
import { ChangePassword } from '@/api'
import RedirectMixin from '@/mixins/redirect'

export default {
  components: {
    MpLabel,
    MpButton,
    MpError,
    MpExternalForm
  },
  data: () => ({
    transitionUrl: null,
    view: {
      errors: [],
      show: false,
      showConfirm: false
    },
    form: {
      password: null,
      passwordConfirm: null
    },
    dialog: {
    }
  }),
  computed: {},
  mixins: [RedirectMixin],
  methods: {
    async clickEntry (ev) {
      await ChangePassword.ChangePassword(this.form)
        .then(async () => {
          const targetUrl = !this.transitionUrl ? null : (await this.getTransitionUrl(this.transitionUrl))
          if (targetUrl) {
            this.$refs.externalForm.doSubmitNoToken(targetUrl)
          } else {
            this.$router.push({ path: '/' })
          }
        })
        .catch(error => { this.view.errors = error.messages })
    }

  },
  created: function () {
    this.transitionUrl = Cookies.get(constantValue.cookieKeyForTransitionalUrl) || ''
    Cookies.remove(constantValue.cookieKeyForTransitionalUrl)
  }
}
</script>
